/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import VerifyCustomerAddress from 'dashboard/components/VerifyCustomerAddress';
import validations from 'shared/helpers/validations';

const WelcomeDetailsDetails = ({ onChangeStep, customer, setCustomer, verificationsSteps }) => {
    const updateCustomerData = form => {
        setCustomer({
            ...customer,
            address: {
                ...form
            }
        });
        onChangeStep(verificationsSteps[2]);
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                addressLine1: customer.address.addressLine1,
                addressLine2: customer.address.addressLine2,
                townCity: customer.address.townCity,
                postCode: customer.address.postCode,
                country: customer.address.country
            }}
            validationSchema={validations.DetailsSchema}
            onSubmit={updateCustomerData}
            render={({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                setFieldValue
            }) => (
                <VerifyCustomerAddress
                    addressLine1={values.addressLine1}
                    addressLine2={values.addressLine2}
                    townCity={values.townCity}
                    postCode={values.postCode}
                    country={values.country}
                    errors={errors}
                    touched={touched}
                    submit={handleSubmit}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    isSubmitting={isSubmitting}
                    setFieldValue={setFieldValue}
                />
            )}
        />
    );
};

WelcomeDetailsDetails.propTypes = {
    onChangeStep: PropTypes.func.isRequired,
    customer: PropTypes.shape({
        onBoarding: PropTypes.bool,
        customerType: PropTypes.string,
        created_at: PropTypes.string,
        discount: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        organisation: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        termsAgreed: PropTypes.bool,
        address: PropTypes.shape({
            addressLine1: PropTypes.string,
            addressLine2: PropTypes.string,
            townCity: PropTypes.string,
            postCode: PropTypes.string,
            country: PropTypes.string
        }),
        setCustomer: PropTypes.func
    }).isRequired,
    setCustomer: PropTypes.func.isRequired,
    verificationsSteps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default WelcomeDetailsDetails;
